"use client"

import { useUserBranchAccess } from "@/features/auth/hooks/use-user-branch-access"

export const DEFAULT_BRANCH_TIMEZONE = "Africa/Kigali"

/** The timezone of the branch resolved from the current tenant route. */
export function useActiveBranchTimezone(branchId?: string | null): string {
  const { primaryBranch, accessibleBranches } = useUserBranchAccess()
  const requestedBranch = branchId
    ? accessibleBranches.find((branch) => branch.id === branchId)
    : null
  const timezone = requestedBranch?.timezone ?? primaryBranch?.timezone
  return timezone && timezone.trim().length > 0 ? timezone : DEFAULT_BRANCH_TIMEZONE
}
